import { QMLTextEdit } from "../CoreApp/QMLTextEdit";
import { AddTextEdit } from "./AddTextEdit";

export function AddMultiLineTextEdit(
  panel,
  xPos,
  yPos,
  width,
  height,
  blankMsg,
  maxLen,
  tabID,
  addBorder,
  numRows
) {
  var te = new QMLTextEdit();
  te.InitTextEdit();
  if (numRows) te.SetNumRows(numRows);
  AddTextEdit(te, panel, xPos, yPos, width, height, blankMsg, maxLen, tabID, addBorder);
  return te;
}
